module.exports = __webpack_public_path__ + "static/media/1_A1_06.ef5dbf53.png";